import { CommissionDataByServiceIdType } from '../model/denomination.types'
import { GAME_PERCENT_FEE_COEF } from '../config/percentFeeGames'

export const transformAmountByCommissionData = (
  price: string,
  commissionData: CommissionDataByServiceIdType,
  isPubgMobile: boolean,
  isNonTopUp: boolean,
  isZeroFee: boolean,
  isGameWithPercentFee = false
) => {
  if (isPubgMobile || isGameWithPercentFee) {
    const coef = isPubgMobile ? Number(commissionData['pubg-mobile'].coef) : GAME_PERCENT_FEE_COEF
    const fee = Number((Number(price) * coef).toFixed(2))

    return {
      base: price,
      fee: `${fee}`,
      total: `${Number(price) + fee}`,
    }
  }

  if (isNonTopUp) {
    const fee = Number(commissionData.vouchers.amount)

    return {
      base: price,
      fee: `${fee}`,
      total: `${Number(price) + fee}`,
    }
  }

  if (isZeroFee) {
    return {
      base: price,
      fee: '0',
      total: price,
    }
  }

  const fee = Number(commissionData.default.amount)

  return {
    base: price,
    fee: `${fee}`,
    total: `${Number(price) + fee}`,
  }
}
